var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryIconCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.89 14.51L27.07 5.88C27.12 5.54 27.01 5.2 26.79 4.95C26.57 4.69 26.24 4.55 25.9 4.55H7.16L6.86 2.96C6.76 2.4 6.27 2 5.7 2H1V4.36H4.73L7.3 18.1C7.4 18.66 7.89 19.06 8.46 19.06H25.19L25.58 16.96H9.44L9.22 15.53H24.73C25.32 15.53 25.82 15.1 25.9 14.51H25.89ZM24.23 9.25H19.63V6.9H24.56L24.24 9.25H24.23ZM14.14 9.25V6.9H18.45V9.25H14.14ZM18.45 10.43V13.17H14.14V10.43H18.45ZM7.6 6.9H12.96V9.25H8.04L7.6 6.9ZM8.26 10.43H12.96V13.17H8.77L8.26 10.43ZM19.63 13.17V10.43H24.07L23.7 13.17H19.63Z",
    fill: "#82BCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.69 20.72C9.44005 20.72 8.42004 21.73 8.42004 22.99C8.42004 24.25 9.43005 25.26 10.69 25.26C11.95 25.26 12.9501 24.25 12.9501 22.99C12.9501 21.73 11.94 20.72 10.69 20.72Z",
    fill: "#82BCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3201 20.72C20.0701 20.72 19.0601 21.73 19.0601 22.99C19.0601 24.25 20.0701 25.26 21.3201 25.26C22.5701 25.26 23.5901 24.25 23.5901 22.99C23.5901 21.73 22.5801 20.72 21.3201 20.72Z",
    fill: "#82BCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryIconCart);
export default __webpack_public_path__ + "static/media/entry_icon_cart.8ae39718a224017b14e0023312e3190f.svg";
export { ForwardRef as ReactComponent };